<template>
  <data-table
    :headers="headers"
    :data="items"
    :hide-delete="true"
    :hide-edit="true"
    :hide-table-bottom="true"
    :loading="isLoading"
  />
</template>

<script>
import DataTableCpfCnpjColumnVue from 'Arch/components/data-table/DataTableColumns/DataTableCpfCnpjColumn.vue';
import DataTable from 'Arch/components/data-table/DataTable.vue';
import DataTableTelefoneColumnVue from 'Arch/components/data-table/DataTableColumns/DataTableTelefoneColumn.vue';
import UserSystemColumnVue from 'App/users/components/columns/UserSystemColumn.vue';

export default {
  name: 'UserExpandableList',
  components: {
    DataTable,
  },
  props: {
    row: {
      type: Object,
      default() {
        return {
          userSystems: [],
        };
      },
    },
    loading: {
      type: Boolean,
    },
  },
  data: () => ({
    headers: [
      {
        text: 'Sistema',
        value: 'system',
        component: UserSystemColumnVue,
      },
      {
        text: 'Telefone',
        value: 'cellPhone',
        component: DataTableTelefoneColumnVue,
      },
      {
        text: 'E-mail',
        value: 'email',
      },
      {
        text: 'Usuário',
        value: 'username',
        component: DataTableCpfCnpjColumnVue,
      },
    ],
  }),
  computed: {
    items() {
      return this.row.userSystems;
    },
    isLoading() {
      return this.loading;
    },
  },
};
</script>
